// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryWizardPanelHeading_root__g-rLM","title":"InquiryWizardPanelHeading_title__3xwNy","subtitle":"InquiryWizardPanelHeading_subtitle__1ujdW"};